<template>
  <div class="company-dialog">
    <b-modal
      id="modalPrintTypeForCustomSummary"
      centered
      @show="onShow"
      :title="modalData.title"
      modal-class="dialog-600 custom-dialog"
      hide-footer
    >
      <b-overlay :show="showOverlay" rounded="sm" opacity="1" variant="white">
        <div class="p-1">
          <h4 class="mt-2">Consideración para la separación de manifiestos</h4>
          <b-form-group class="ml-2" v-slot="{ ariaDescribedby }">
            <b-form-radio class="mt-1 mb-2" v-model="separationType" @change="onChangeSeparationType" :disabled="modalData.disabledStandard" :aria-describedby="ariaDescribedby" name="separation-type-radios" value="standard">
              Automática: por distintos <b>Courier, Bodega y Marketplace. </b>
            </b-form-radio>
            <b-form-radio v-model="separationType" @change="onChangeSeparationType" :disabled="modalData.disabledExtended" :aria-describedby="ariaDescribedby" name="separation-type-radios" value="extended">
              Personalizada:  por distintos <b>Courier y Bodega,</b> respetando los <b>filtros aplicados </b>
              (ya sea general o específico).
            </b-form-radio>
          </b-form-group>
  
          <!-- Alerta con numero de manifiestos -->
          <div v-if="modalData.showCountAlert">
            <b-alert class="p-1 mt-2 col-sm-12 col-md-12 col-lg-12" variant="primary" show>
              <div class="d-flex">
                <feather-icon size="20" class="mr-50" icon="InfoIcon"/>
                <span>
                  Total de manifiestos a generar: <b>{{modalData.summariesQty}}</b>
                </span>
              </div>
            </b-alert>
          </div>
          <div v-else>
            <b-alert class="p-1 mt-2 col-sm-12 col-md-12 col-lg-12" variant="danger" show>
              <div class="d-flex">
                <feather-icon size="20" class="mr-50" icon="InfoIcon"/>
                <span>
                  Ha ocurrido un error al agrupar los envíos. Intente nuevamente comuníquese con soporte técnico si el problema persiste.
                </span>
              </div>
            </b-alert>
          </div>
        </div>

        <div class="mt-0 text-center">
          <div class="container my-1">
            <div class="row d-flex justify-content-around">
              <b-button class="col-md-3" variant="warning" :disabled="disabled.printButtons" @click="selectPrintType(1)"> <b-spinner v-if="loading.type_1" type="grow"></b-spinner> <span v-else>{{$t('Zebra')}}</span> </b-button>
              <b-button class="col-md-3" variant="warning" :disabled="disabled.printButtons" @click="selectPrintType(2)"> <b-spinner v-if="loading.type_2" type="grow"></b-spinner> <span v-else>{{$t('Hoja Carta')}}</span> </b-button>
              <b-button class="col-md-3" variant="warning" :disabled="disabled.printButtons" @click="selectPrintType(3)"> <b-spinner v-if="loading.type_3" type="grow"></b-spinner> <span v-else>{{$t('ZPL')}}</span> </b-button>
            </div>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import DeliveryService from '../delivery.service'
export default {
  props: {
    deliveriesIds: {required: false, type: Array},
    selectedQuickFilter: {required: false, type: String},
    serviceType: {required: false, type: String},
    firstPrint: {required: false, type: Boolean},
    dataMessage: {required: false, type: Object},
    refreshTable: {required: false, type: Boolean}
  },
  data() {
    return {
      deliveryService: new DeliveryService(this),
      modalData: {
        title: 'Tipo de impresión',
        summariesQty: null,
        disabledStandard: false,
        disabledExtended: false,
        showCountAlert: false
      },
      filterMap: {
        envia_flex: 'enviaflex_filter',
        meli_flex: 'meliflex_filter',
        me_1: 'me1_filter'
      },
      internalIds: [],
      showOverlay: false,
      groupDeliveriesResp: null,
      user: null,
      separationType: 'standard',
      permissions: {
        showDeleteDeliveries: false,
        blockDeleteDeliveries: false,
        customSummariesV2: false,
        showSkuColumn: false
      },
      loading: {
        type_1: false,
        type_2: false,
        type_3: false
      },
      disabled: {
        printButtons: false
      }
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    setInitialData () {
      this.user = this.$session.get('cas_user')
      this.modalData.title = this.firstPrint ? 'Tipo de impresión' : 'Reimprimir etiqueta'
      this.setPermissions()
    },
    setPermissions() {
      this.permissions.customSummariesV2 = this.user?.user_access?.custom_summaries_v2
    },
    onChangeSeparationType() {
      this.modalData.summariesQty = this.groupDeliveriesResp[this.separationType].total_summaries
      // if (this.separationType === 'extended') {
      //   this.modalData.summariesQty = 3

      //   this.groupDeliveriesResp = resp.data
      //   this.modalData.summariesQty = this.groupDeliveriesResp[this.separationType].total_summaries
      // } else {
      //   this.modalData.summariesQty = 5
      // }
    },
    selectPrintType (type) {
      switch (type) {
      case 1: 
        this.loading.type_1 = true
        break
      case 2: 
        this.loading.type_2 = true
        break
      case 3: 
        this.loading.type_3 = true
        break
      }
      this.disabled.printButtons = true
      this.printDeliveriesByGroup(type)
    },
    printDeliveriesByGroup(type) {
      const groupKey =  this.groupDeliveriesResp[this.separationType].key
      const queryParams = {
        key: groupKey,
        print_type: type,
        deliveries: this.deliveriesIds
      }

      if (this.selectedQuickFilter && this.separationType === 'extended') queryParams[this.filterMap[this.selectedQuickFilter]] = true

      this.deliveryService.callService('printDeliveriesByGroup', queryParams)
        .then(resp => {
          this.$emit('sendLabelResponse', resp.data)
          this.$bvModal.hide('modalPrintTypeForCustomSummary')
        })
        .catch(error => {
          this.$alert(this.$t('msg-problem-delivery-label', {code: error}))
        })
        .finally(() => {
          this.loading.type_1 = false
          this.loading.type_2 = false
          this.loading.type_3 = false
          this.disabled.printButtons = false
        })
    },
    printLabelsEstambul (qry) {
      let name = 'getDeliveryLabels'
      if (this.firstPrint) name = 'postDeliveriesPrint'
      this.deliveryService.callService(name, qry, qry)
        .then(resp => {
          this.$emit('sendLabelResponse', resp.data)
        })
        .catch(error => {
          this.$alert(this.$t('msg-problem-delivery-label', {code: error}))
        })
        .finally(_ => {
          this.loading.type_1 = false
          this.loading.type_2 = false
          this.loading.type_3 = false
          this.disabled.printButtons = false
        })
    },
    assignAndPrint (qry) {
      this.loading.assignSummary = true
      this.deliveryService.callService('assignToSummary', qry, null)
        .then(resp => {
          this.$emit('sendLabelResponse', resp.data, this.refreshTable)
        })
        .catch(error => {
          this.$alert(this.$t('msg-problem-delivery-label', {code: error}))
        })
        .finally(_ => {
          this.loading.type_1 = false
          this.loading.type_2 = false
          this.loading.type_3 = false
          this.disabled.printButtons = false
        })
    },
    onShow() {
      this.separationType = 'standard'
      this.modalData.disabledStandard = false
      this.modalData.disabledExtended = false
      this.getGroupsDeliveries()
    },
    getGroupsDeliveries() {
      const filterMap = {
        envia_flex: 'enviaflex_filter',
        meli_flex: 'meliflex_filter',
        me_1: 'me1_filter'
      }
      const payload = {
        deliveries: this.deliveriesIds
      }
      if (this.selectedQuickFilter) payload[filterMap[this.selectedQuickFilter]] = true
      /**
       * Casos posibles:
       * - 200: Existe standard y extended. Se muestra ambos 'total_summaries'.
       * - 200: Existe solo standard. Se muestra solo la opción standard y extended se deshabilita.
       * - 200: Existe solo extended. NO APLICA
       * - 400: No existe ninguno. Te frena y avisa del error.
       * - 500: Error en el servidor. Te frena y avisa del error.
       */
      this.showOverlay = true
      this.disabled.printButtons = false
      this.deliveryService.callService('getGroupDeliveries', payload, null)
        .then(resp => {
          this.groupDeliveriesResp = resp.data
          this.modalData.summariesQty = resp.data.standard.total_summaries
          this.modalData.showCountAlert = true
          if (this.groupDeliveriesResp.extended.total_summaries > 0) {
            this.modalData.disabledExtended = false
          } else {
            this.modalData.disabledExtended = true
          }
        })
        .catch(error => {
          this.modalData.showCountAlert = false
          this.disabled.printButtons = true
          this.modalData.disabledStandard = true
          this.modalData.disabledExtended = true
        })
        .finally(_ => {
          this.showOverlay = false
        })
    }

  }
}
</script>

<style>
.message-print {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border-color: #faebcc;
  border: 1px solid #faebcc;
  border-radius: 4px;
}
</style>